import React from 'react';
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import RotuloSeplag from '../../../../../components/RotuloSeplag';

import style from "./style.module.scss";

const CustomizedContent = (item) => {

  return (
    <Card>

      <div className={style.cabecalho}>
        <div className={`p-card-title ${item.auditoriaDTO.ultimaVersao && style.cardTitle}`}>
          {item.auditoriaDTO.revtypeFormatada}
          {item.auditoriaDTO.ultimaVersao && (
            <i className="pi pi-check " style={{ color: "#077F41", fontSize: "1rem", fontWeight: 600 }}>
              {" "}
              última versão
            </i>
          )}
        </div>
        <div className="p-card-subtitle">{`${item.auditoriaDTO.usuario}  -  ${item.auditoriaDTO.dataFormatada}`}</div>
      </div>

      <hr className={style.separador} />
      <div className="p-grid">
        <RotuloSeplag nome="Nome Beneficiário" cols="12 6">
          <InputText value={item.nomeServ} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="CPF" cols="12 6">
          <InputText value={item.pessoa.numrCpf} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="RG" cols="12 6">
          <InputText value={item.pessoa.numrRg} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Órgão Expedidor do RG" cols="12 6">
          <InputText value={item.pessoa.clasOrgaoEmissorRg} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Unidade Federativa (UF)" cols="12 6">
          <InputText value={item.pessoa.ufRg.siglUf} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Data Emissão" cols="12 6">
          <InputText value={item.dataEmissaoCert} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Nome da Mãe" cols="12 6">
          <InputText value={item.pessoa.nomeMae} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Matrícula Beneficiário" cols="12 6">
          <InputText value={item.numrMatrPessoalServ} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Data de Nascimento" cols="12 6">
          <InputText value={item.pessoa.dataNascimento} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Nº Certidão de Crédito" cols="12 6">
          <InputText value={item.numrCert} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Tipo" cols="12 6">
          <InputText value={item.tipoCertidao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Tipo Validado" cols="12 6">
          <InputText value={item.tipoCertidaoValidada?.nomeTipoCertidao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Amparo Legal" cols="12 6">
          <InputText value={item.amparoLegalObrigacao?.descAmparoLegal} disabled />
        </RotuloSeplag>

       <RotuloSeplag nome="Órgão de Origem" cols="12 6">
          <InputText value={item.orgaoLotacaoCs.nomeOrgao} disabled />
        </RotuloSeplag> 

        {/* <RotuloSeplag nome="Novo órgão de origem" cols="12 6">
          <InputText value={item.orgao?.descOrgao} disabled />
        </RotuloSeplag> */}

        <RotuloSeplag nome="Data Quitação" cols="12 6">
          <InputText value={item.dataQuitacaoCert} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Data Autenticação" cols="12 6">
          <InputText value={item.dataAutenticCert} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Data Compensação" cols="12 6">
          <InputText value={item.dataCompensCerto} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Data emissão" cols="12 6">
          <InputText value={item.dataEmissaoCert} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Data Entrega" cols="12 6">
          <InputText value={item.dataEntregaCert} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Número Processo Quitação" cols="12 6">
          <InputText value={item.numrProcessoQuitacao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Número Processo Autenticação" cols="12 6">
          <InputText value={item.numrProcessoAutenticacao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Número Processo Compensação" cols="12 6">
          <InputText value={item.numrProcessoCompensacao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Número Processo SAD" cols="12 6">
          <InputText value={item.numrProcessoSad} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Correção" cols="12 6">
          <InputText value={item.valrCorrecao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Multa" cols="12 6">
          <InputText value={item.valrMulta} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Compensado" cols="12 6">
          <InputText value={item.valrCompensado} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Honorário Advocatício" cols="12 6">
          <InputText value={item.valrHonAdv} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Remanescente" cols="12 6">
          <InputText value={item.valrRemanescente} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Bruto" cols="12 6">
          <InputText value={item.valrBruto} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Desconto" cols="12 6">
          <InputText value={item.valrDesconto} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Liquido" cols="12 6">
          <InputText value={item.valrLiquido} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Complemento" cols="12 6">
          <InputText value={item.descProcessoSad} disabled />
        </RotuloSeplag>
      </div>
    </Card>
  );
};


export default CustomizedContent;